import { render, staticRenderFns } from "./FestivalModul.vue?vue&type=template&id=31189a60&scoped=true"
import script from "./FestivalModul.vue?vue&type=script&lang=js"
export * from "./FestivalModul.vue?vue&type=script&lang=js"
import style0 from "./FestivalModul.vue?vue&type=style&index=0&id=31189a60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31189a60",
  null
  
)

export default component.exports